import React, { useState } from 'react';
import { Trans } from '@lingui/macro';
import '../styles/_questions.scss';

const FAQSupport = () => {
  const initialActiveIndex = Array.from({ length: 9 }, (_, index) => ({
    index,
    isActive: false
  }));

  const [activeIndex, setIsActiveIndex] = useState(initialActiveIndex);

  const handleClick = (index) => {
    setIsActiveIndex((prev) => {
      return prev.map((item) => {
        if (item.index === index) {
          return { ...item, isActive: !item.isActive };
        }
        return { ...item, isActive: false };
      });
    });
  };

  return (
    <section className='Question-section' style={{ paddingBottom: '4rem' }}>
      <div className='container'>
        <div className='app-haeding section-content feedbacks-heading'>
          <h2 style={{ fontWeight: 'normal', whiteSpace: 'nowrap', textAlign: 'center' }}><Trans>Foire aux Questions - App</Trans></h2>
        </div>
        <div className="QuestionAccordion mt-4">
          <div className="faq-container" style={{ maxWidth: '800px', margin: '0 auto' }}>
            <div className="accordion-wrapper">
            <div className={`accordion ${activeIndex[0].isActive ? "active-accordion" : 'inactive-accordion'}`}>
              <input type="checkbox" onChange={(e) => handleClick(0)} name="checkbox-1" id="support-check1" />
              <label className="accordion-label" htmlFor="support-check1"><Trans>🔐 Comment accéder à l'app Repat ?</Trans></label>
              <div className="accordion-content">
                <p>
                  <Trans>
                    L'accès est réservé aux membres validés de Repat. Si vous avez reçu un email de confirmation, vous pouvez vous connecter avec l'adresse utilisée lors de votre inscription.
                  </Trans>
                </p>
              </div>
            </div>

            <div className={`accordion ${activeIndex[1].isActive ? "active-accordion" : 'inactive-accordion'}`}>
              <input type="checkbox" onChange={(e) => handleClick(1)} name="checkbox-2" id="support-check2" />
              <label className="accordion-label" htmlFor="support-check2"><Trans>🔐 Je n'arrive pas à me connecter, que faire ?</Trans></label>
              <div className="accordion-content">
                <p>
                  <Trans>
                    Assurez-vous d'utiliser l'adresse exacte avec laquelle vous avez été inscrit. Si le problème persiste, contactez notre équipe à support[at]repat.africa.
                  </Trans>
                </p>
              </div>
            </div>

            <div className={`accordion ${activeIndex[2].isActive ? "active-accordion" : 'inactive-accordion'}`}>
              <input type="checkbox" onChange={(e) => handleClick(2)} name="checkbox-3" id="support-check3" />
              <label className="accordion-label" htmlFor="support-check3"><Trans>👥 Quelles sont les fonctionnalités disponibles dans l'app ?</Trans></label>
              <div className="accordion-content">
                <ul>
                  <li><Trans>Consultation des profils des membres</Trans></li>
                  <li><Trans>Ajout et gestion de vos contacts</Trans></li>
                  <li><Trans>Messagerie (chat privé et groupes)</Trans></li>
                  <li><Trans>Recherche multicritère (pays, langues, secteur, intérêts, etc.)</Trans></li>
                  <li><Trans>Gestion de votre profil personnel</Trans></li>
                </ul>
              </div>
            </div>

            <div className={`accordion ${activeIndex[3].isActive ? "active-accordion" : 'inactive-accordion'}`}>
              <input type="checkbox" onChange={(e) => handleClick(3)} name="checkbox-4" id="support-check4" />
              <label className="accordion-label" htmlFor="support-check4"><Trans>💬 Comment envoyer un message à un autre membre ?</Trans></label>
              <div className="accordion-content">
                <p>
                  <Trans>
                    Une fois qu'un contact est accepté, vous pouvez lui envoyer un message via la messagerie intégrée. Vous pouvez également rejoindre ou créer des groupes de discussion.
                  </Trans>
                </p>
              </div>
            </div>

            <div className={`accordion ${activeIndex[4].isActive ? "active-accordion" : 'inactive-accordion'}`}>
              <input type="checkbox" onChange={(e) => handleClick(4)} name="checkbox-5" id="support-check5" />
              <label className="accordion-label" htmlFor="support-check5"><Trans>🚫 Puis-je supprimer un contact ou bloquer quelqu'un ?</Trans></label>
              <div className="accordion-content">
                <p>
                  <Trans>
                    Oui, vous pouvez gérer vos contacts à tout moment depuis la section "Mes contacts". Les options de suppression et de blocage sont disponibles dans le profil de chaque membre.
                  </Trans>
                </p>
              </div>
            </div>

            <div className={`accordion ${activeIndex[5].isActive ? "active-accordion" : 'inactive-accordion'}`}>
              <input type="checkbox" onChange={(e) => handleClick(5)} name="checkbox-6" id="support-check6" />
              <label className="accordion-label" htmlFor="support-check6"><Trans>💳 L'accès à l'app est-il payant ?</Trans></label>
              <div className="accordion-content">
                <p>
                  <Trans>
                    L'application est gratuite à l'installation, mais réservée aux membres Repat.
                  </Trans>
                </p>
              </div>
            </div>

            <div className={`accordion ${activeIndex[6].isActive ? "active-accordion" : 'inactive-accordion'}`}>
              <input type="checkbox" onChange={(e) => handleClick(6)} name="checkbox-7" id="support-check7" />
              <label className="accordion-label" htmlFor="support-check7"><Trans>⚙️ Comment modifier ou annuler mon abonnement ?</Trans></label>
              <div className="accordion-content">
                <p>
                  <Trans>
                    Les abonnements sont gérés en dehors de l'app, via notre site officiel. Pour toute demande liée à l'abonnement, merci de nous écrire à support[at]repat.africa.
                  </Trans>
                </p>
              </div>
            </div>

            <div className={`accordion ${activeIndex[7].isActive ? "active-accordion" : 'inactive-accordion'}`}>
              <input type="checkbox" onChange={(e) => handleClick(7)} name="checkbox-8" id="support-check8" />
              <label className="accordion-label" htmlFor="support-check8"><Trans>🛠️ L'app ne fonctionne pas correctement, que faire ?</Trans></label>
              <div className="accordion-content">
                <p>
                  <Trans>
                    Veuillez forcer la fermeture de l'app puis redémarrer. Si le problème persiste, merci de nous signaler le bug avec une capture d'écran à support[at]repat.africa.
                  </Trans>
                </p>
              </div>
            </div>

            <div className={`accordion ${activeIndex[8].isActive ? "active-accordion" : 'inactive-accordion'}`}>
              <input type="checkbox" onChange={(e) => handleClick(8)} name="checkbox-9" id="support-check9" />
              <label className="accordion-label" htmlFor="support-check9"><Trans>📩 Contact</Trans></label>
              <div className="accordion-content">
                <p>
                  <Trans>
                    Si vous ne trouvez pas votre réponse ici, vous pouvez nous contacter directement à :
                    <br />📧 <strong>support[at]repat.africa</strong>
                    <br />Nous vous répondrons sous 48h.
                  </Trans>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </section>
  )
}

export default FAQSupport
